export const metaDescriptions = {
	homepage:
		'Level up your programming skills with Node Guardians, a fantasy themed learning platform for Smart Contract developers. Join the order today!',
	devhub:
		'Uncover the secrets of Web3 through epic fantasy quests. Earn rewards and level up your Smart Contract skills in this immersive learning experience.',
	character: 'Unlock rewards and forge legendary equipment. Hone your developer skills and conquer the realm of Web3.',
	journal:
		'Track your progress and achievements, and reflect on your conquests while you grow as a skilled smart contract developer.',
	support:
		'Find answers to your questions and gain insights into Node Guardians, a fantasy themed gamified learning platform for Smart Contract developers.',
	staking:
		'We provide infrastructure for non-custodial staking that places an emphasis on availability and security. Doing so, we enable users to stake their assets, act as validators in the ecosystem, and earn rewards.',
	userProfile: (username: string, level: number) =>
		`Check out ${username} (lv.${level}) profile on Node Guardians! A fantasy themed gamified platform for smart contract developers.`
};
